import {getTarget} from "@COMPONENTS/common/commonUtil";
import useCountdown from "@/hooks/common/useCountdown";
import * as style from "@COMPONENTS/style/productlist/departurepopup";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import errorImg from "@PUBLIC/P/images/ico/ico_nodata.png";
import {GlobalGoodsLive} from "@QUERIES/bff/global/useGlobalGoodsLive";
import {BannerContents as BannerContentsType} from "@QUERIES/essential/banner/useBannerContents";
import {BannerGoodsDeal} from "@QUERIES/essential/banner/useBannerGoodsDeal";
import {format} from "@yb/utils";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import {SyntheticEvent} from "react";
import {useTaggingClick} from "@/hooks/common/useTagging";

const daykor = ["일", "월", "화", "수", "목", "금", "토"];

const BannerContents = ({contents}: {contents: BannerContentsType[]}) => {
	// 이미지 없을 경우 구름 이미지 표시
	const imageOnError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
		e.currentTarget.src = errorImg;
		e.currentTarget.className = "img-error";
	};

	const {taggingClick} = useTaggingClick("pkg_select_promo_calender", {selectDiv: "calenderMidBanner"});

	return (
		<style.EventBanner>
			{contents &&
				contents.map((item, index) => (
					<a
						href={`${publicRuntimeConfig.ENV_PACKAGE_URL}${item.link}`}
						key={index}
						target={getTarget(item.target)}
						onClick={() => taggingClick(item)}
					>
						<img src={`${publicRuntimeConfig.ENV_CIMG_CDN_URL}${item.imgPath}`} alt={item.alt} onError={imageOnError} />
					</a>
				))}
		</style.EventBanner>
	);
};

const BannerYellowLive = ({live}: {live: GlobalGoodsLive}) => {
	dayjs.extend(isBetween); // isBetween 사용
	const {dspYn, liveDt, liveTime} = live;
	// 방송 노출 조건 Y가 아닌 경우 - 노출 X
	if (dspYn !== "Y") return <></>;

	const liveStartDate = dayjs(liveDt);
	const liveEndDate = liveStartDate.add(Number(liveTime), "minute");

	const today = dayjs();

	const LiveText = () => {
		if (today.isBefore(liveStartDate)) {
			const countdown = useCountdown(liveStartDate);
			return (
				<>
					<style.LiveDate>COMING SOON</style.LiveDate>
					<style.LiveState>{countdown}</style.LiveState>
				</>
			);
		} else if (today.isBetween(liveStartDate, liveEndDate)) {
			return (
				<>
					<style.LiveDate>ON AIR</style.LiveDate>
					<style.LiveState>실시간 방송 중</style.LiveState>
				</>
			);
		} else {
			const formattedDate = `${liveStartDate.format("MM/DD")}(${daykor[liveStartDate.day()]}) ${liveStartDate.format(
				"HH:mm",
			)}`;
			return (
				<>
					<style.LiveDate>{formattedDate}</style.LiveDate>
					<style.LiveState>방영 완료</style.LiveState>
				</>
			);
		}
	};

	return (
		<style.BannerYellowLive>
			<a href={`${publicRuntimeConfig.ENV_PORTAL_URL}/promotion/yellowLive`}>
				<style.LiveText>
					<style.LiveTit>최대 혜택으로 떠나는 생생한 여행</style.LiveTit>
					{/* LiveText */}
					<LiveText />
				</style.LiveText>
				<style.LiveLink>
					<span>바로가기</span>
				</style.LiveLink>
			</a>
		</style.BannerYellowLive>
	);
};

const BannerYellowPangDeal = ({deal}: {deal: BannerGoodsDeal}) => {
	const PangdealText = () => {
		const targetDate = dayjs(deal.dealEdTm).add(1, "minute");
		const countdown = useCountdown(targetDate);
		return (
			<style.PangdealText>
				<p>
					<style.PangdealProduct>{deal.dealType === "T" ? "타임특가" : "선착순특가"}</style.PangdealProduct>
					&nbsp;
					<style.PangdealDate>
						{deal.dealType === "T" ? countdown ?? "종료" : `상품 ${deal.dealRervCnt || 0}개`}
					</style.PangdealDate>
					{countdown !== null && ` 남음`}
				</p>
				<p>{`${
					deal.dealRervCnt > 0 || countdown !== null
						? `${format.koKRFormatNumber(deal.price - deal.dealGoodsPrice)}원 즉시할인가격`
						: ``
				}`}</p>
			</style.PangdealText>
		);
	};

	return (
		<style.BannerYellowpangdeal>
			<a target="_self" href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/promotion/yellowPangDeal.yb`}>
				<style.PangdealPrice>
					{/* PangdealText */}
					<PangdealText />
				</style.PangdealPrice>
				<style.PangdealLink>
					<span>전체보기</span>
				</style.PangdealLink>
			</a>
		</style.BannerYellowpangdeal>
	);
};

export {BannerContents, BannerYellowLive, BannerYellowPangDeal};
